import "../style/page/pharmacy.scss";
import React, { useEffect, useState, useMemo } from "react";
import { useSelector, useDispatch } from "react-redux";
import { NavLink } from "react-router-dom";
import { Tooltip as ReactTooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";
import BasicTable from "../maincomponent/reacttable/table";
import axios from "axios";
import { pharmacy, updateproduct, pharmacyexcel } from "../../text/apidata";
import { pharmacypopup, pharmacyid, sidebar } from "../redux/reducer/counterslice";
import PharmacyForm from "../form/pharmacyform";
import noimage1 from "../../assets/images/noimage.png";
import Swal from "sweetalert2";

export default function Pharmacy(props) {
  const sideactive = useSelector((state) => state.counter.sidebarnav);
  const pharmacystate = useSelector((state) => state.counter.pharmacypopup);
  const [searchQuery, setSearchQuery] = useState("");
  const [tableheaderdata, settableheaderdata] = useState([]);
  const [datacount, setdatacount] = useState();
  const [dtpageindex, setdtPageindex] = useState(1);
  const [dtpagesize, setdtPagesize] = useState(10);
  const [search, setsearch] = useState(false);
  const dispatch = useDispatch();
  const pharmaid = useDispatch();
  let roledata = localStorage.getItem("role");
  const [isactivefilterdata, setisactivefilterdata] = useState("")


  const handleSubmit = (event) => {
    event.preventDefault();
  };
  useEffect(() => {
    if (searchQuery != "") {

      // console.log(dtpageindex, dtpagesize);
      const hasNumbers = /[0-9]/.test(searchQuery);
      const hasLetters = /[a-zA-Z]/.test(searchQuery);
      const hasSpecialChars = /[!@#$%^&*()_+{}\[\]:;<>,.?~\\-]/.test(searchQuery);
      if (hasNumbers || hasLetters || hasSpecialChars) {

        props.loaderchange("true");
        axios({
          method: "get",
          url: pharmacy,
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token") + "",
          },
          params: {
            page: dtpageindex,
            page_size: dtpagesize,
            search: searchQuery,
            is_active: isactivefilterdata
          },
        })
          .then((res) => {
            console.log(res);
            setdatacount(res.data.data_count);
            settableheaderdata(res.data.data);
            props.loaderchange("false");
          })
          .catch((error) => {
            console.log(error);
            props.loaderchange("false");
            // setdtPageindex(dtpageindex-1)
            props.popupalert("true");
            props.popuptext("No Data Available");
            setTimeout(() => {
              props.popupalert("false");
            }, 2000);
          });
      }
    } else {
      props.loaderchange("true");
      axios({
        method: "get",
        url: pharmacy,
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token") + "",
        },
        params: {
          page: dtpageindex,
          page_size: dtpagesize,
          search: searchQuery,
          is_active: isactivefilterdata
        },
      })
        .then((res) => {
          console.log(res);
          setdatacount(res.data.data_count);
          settableheaderdata(res.data.data);
          props.loaderchange("false");
        })
        .catch((error) => {
          console.log(error);
          props.loaderchange("false");
          // setdtPageindex(dtpageindex-1)
          props.popupalert("true");
          props.popuptext("No Data Available");
          setTimeout(() => {
            props.popupalert("false");
          }, 2000);
        });
    }
  }, [dtpageindex, dtpagesize, search, searchQuery, pharmacystate, isactivefilterdata]);

  const pagesize = (arg) => {
    setdtPagesize(arg);
  };

  const pageindex = (arg) => {
    setdtPageindex(arg);
  };

  const dropdownhandlechange = (e) => {
    // setAge(e.target.value)

    if (e) {
      //   specialitynav("/SpecialityForm");
      dispatch(pharmacypopup("pharmacyedit"));
      pharmaid(pharmacyid(e));
    }
  };
  const columns = useMemo(
    () => [
      // here
      {
        Header: "Logo",
        accessor: "",

        Cell: (row) => {
          return (
            <>
              {row.row.original.logo_url &&
                row.row.original.logo_url.length > 0 ? (
                row.row.original.logo_url.map((ele) => {
                  return (
                    <>
                      <img
                        style={{
                          height: "2.5rem",
                          width: "2.5rem",
                          borderRadius: "50%",
                          margin: "4px",
                        }}
                        src={ele ? ele : noimage1}
                      ></img>
                    </>
                  );
                })
              ) : (
                <>
                  <img
                    style={{
                      height: "2.5rem",
                      width: "2.5rem",
                      borderRadius: "50%",
                      margin: "4px",
                    }}
                    src={noimage1}
                  ></img>
                </>
              )}
            </>
          );
        },
      },

      {
        Header: "Product Name",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={row.row.original.product_name}
              >
                {row.row.original.product_name}
              </p>
            </>
          );
        },
      },
      {
        Header: "Price",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={row.row.original.MRP}
              >
                {parseFloat(row.row.original.MRP).toFixed(2)}
              </p>
            </>
          );
        },
      },
      {
        Header: "Stock",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={row.row.original.current_stock}
              >
                {row.row.original.current_stock}
              </p>
            </>
          );
        },
      },

      {
        Header: "Discount",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={row.row.original.discount}
              >
                {String(row.row.original.discount)}
              </p>
            </>
          );
        },
      },
      {
        Header: "Is Active",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={
                  row.row.original.is_active == false
                    ? "No"
                    : "Yes"
                }
              >
                {row.row.original.is_active == false ? (
                  <p style={{ color: "red", fontWeight: 700 }}>No</p>
                ) : (
                  <p style={{ color: "green", fontWeight: 700 }}>Yes</p>
                )}
              </p>
            </>
          );
        },
      },
      {
        Header: "Medicine Type",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={
                  row.row.original.medicine_type == 0
                    ? "Essentials"
                    : row.row.original.medicine_type == 1
                      ? "General Medicine"
                      : row.row.original.medicine_type == 2
                        ? "Most Bought"
                        : ""
                }
              >
                {row.row.original.medicine_type == 0
                  ? "Essentials"
                  : row.row.original.medicine_type == 1
                    ? "General Medicine"
                    : row.row.original.medicine_type == 2
                      ? "Most Bought"
                      : ""}{" "}
              </p>
            </>
          );
        },
      },

      {
        Header: "Actions",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <div class="actions">
                <button
                  type="button"
                  class="btn btn-danger btn-sm edit"
                  onClick={(e) => dropdownhandlechange(row.row.original.id, e)}
                >
                  <i class="bi bi-pencil-fill"></i> Edit
                </button>
              </div>
            </>
          );
        },
      },
    ],
    []
  );

  const creatfunction = (e) => {
    dispatch(pharmacypopup("create"));
  };

  const loaderchangechild = (arg) => {
    // console.log(arg,"jkh")
    props.loaderchange(arg);
  };
  const popupalertchild = (arg) => {
    props.popupalert(arg);
  };
  const popuptextchild = (arg) => {
    props.popuptext(arg);
  };
  const getdata = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do You Want to Update Data ?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
    }).then((result) => {
      if (result.isConfirmed) {
        axios({
          method: "get",
          url: updateproduct,
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token") + "",
          },
        })
          .then((res) => {
            Swal.fire({
              position: 'top-end',
              icon: 'success',
              title: 'Data Has Been Upadated',
              showConfirmButton: false,
              timer: 1500
            })

          })
          .catch((error) => { });
      }
    });
  }

  const datadownload = () => {
    Swal.fire({
      title: 'Are you sure?',
      text: "Do You Want To Download The Data?",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes'
    }).then((result) => {
      if (result.isConfirmed) {
        axios({
          method: 'get',
          url: pharmacyexcel,
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token") + "",
          },
        }).then((res) => {
          window.open(res.data.data, '_self')
          // Swal.fire(
          //   'Deleted!',
          //   'Your file has been deleted.',
          //   'success'
          // )

          console.log(res)

        }).catch((err) => {

        })
      }
    })
  }

  return (
    <>
      <div className={sideactive ? "pharma-sa" : "pharmapage"}>
        <div class="page-header">
          <div class="row">
            <div class="col-sm-7 col-auto">
              <h3 class="page-title">Pharmacy</h3>
              <ul class="breadcrumb">
                <li class="breadcrumb-item">
                  <NavLink
                    style={{ textDecoration: "none", color: "#333333" }}
                    to={"/"}
                    onClick={(e) => {
                      dispatch(sidebar("DashBoard"))
                    }}
                  >
                    Dashboard
                  </NavLink>
                </li>
                <li class="breadcrumb-item active">Pharmacy</li>
              </ul>
            </div>
            <div class="col-sm-5 col">
              <a
                onClick={(e) => creatfunction(e)}
                style={{
                  backgroundColor: "#1b5a90",
                  border: "1px solid #1b5a90",
                  color: "white",
                }}
                data-toggle="modal"
                class="btn btn-primary float-right mt-2"
              >
                Add
              </a>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div className="card-body" style={{ padding: "1.5rem" }}>
                <form onSubmit={handleSubmit}
                  style={{ display: "flex", justifyContent: "space-between" }}

                >
                  <div
                    class="input-group rounded"
                    style={{ width: "250px", height: "40px" }}
                  >
                    <input
                      type="search"
                      class="form-control rounded"
                      aria-label="Search"
                      aria-describedby="search-addon"
                      value={searchQuery}
                      onKeyDown={(e) => {
                        if (e.target.value.length === 0 && e.which === 32) { e.preventDefault(); }
                      }}

                      onInput={(e) => {
                        if (e.target.value.length <= "100") {
                          setSearchQuery(e.target.value);

                        }
                        else {
                          e.preventDefault()
                        }
                      }}
                      // onKeyDown={(e)=>{if(e.which=="32"){
                      //   e.preventDefault()
                      // }}}

                      min="0"
                      max="10"
                      label="Search"
                      placeholder="Search..."
                      required
                    />
                    <span
                      class="input-group-text border-0 bg-transparent"
                      id="search-addon"
                    >
                      <i
                        class="bi bi-search"
                        style={{
                          color: "#1b5a90",
                          width: "20px",
                          height: "20px",
                        }}
                      ></i>
                    </span>
                  </div>
                  <div>
                    <>
                      {/* <button className="getdata" onClick={(e)=>{
                    getdata()
                  }}>
                    <div class="spinner">
                      <i class="bi bi-chevron-double-down"></i>
                    </div>
                    Update Pharmacy Data
                  </button> */}
                      <div align="center" type="button">
                        <a class="dnbtn" onClick={(e) => {
                          datadownload();
                        }}></a>
                      </div>
                    </>
                  </div>

                </form>

                <div className="table-responsive">
                  <BasicTable
                    columns={columns}
                    data={tableheaderdata}
                    pagesize={pagesize}
                    pageindex={pageindex}
                    dtpagesize={dtpagesize}
                    dtpageindex={dtpageindex}
                    datacount={datacount}
                    isactive={true}
                    isactivefilterdata={isactivefilterdata}
                    setisactivefilterdata={setisactivefilterdata}

                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <ReactTooltip
          id="my-tooltip"
          arrowColor="transparent"
          place="bottom-start"
          delayShow={200}
          style={{
            backgroundColor: "#707070",
            fontSize: "10px",
            textAlign: "center",
            padding: "5px",
            fontWeight: 400,
          }}
        />
      </div>
      {pharmacystate == "pharmacyedit" || pharmacystate == "create" ? (
        <PharmacyForm
          loaderchange={loaderchangechild}
          popupalert={popupalertchild}
          popuptext={popuptextchild}
        />
      ) : (
        ""
      )}
    </>
  );
}
